import React from 'react'
import { Body, Box } from '../layout'
import './Radio.scss'

export const Radio = ({ name, label }) => (
  <Box column gap={4}>
    <Body alt small weight={600} lineHeight={1}>{label}</Body>
    <Box gap={16}>
      <label>
        <Box gap={8} alignItems="center">
          <input type="radio" name={name} value={1} />
          <span className="radio"></span>
          <Body alt size={16}>Yes</Body>
        </Box>
      </label>
      <label>
        <Box gap={8} alignItems="center">
          <input type="radio" name={name} value={0} />
          <span className="radio"></span>
          <Body alt size={16}>No</Body>
        </Box>
      </label>
    </Box>
  </Box>
)